module.exports = __webpack_public_path__ + "static/media/matching-score-rank-5.99b4db9d.png";